/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Validation Token Types
 */
export enum ValidationTokenType {
    Confirmation = 'confirmation',
    ResetPassword = 'reset-password',
    GroupInvitation = 'group-invitation',
    PerformerOnboarding = 'performer-onboarding',
    CharacterPhotoCapture = 'character-photo-capture',
}
